export const DashboardCardSkeleton = () => {
  return <div className="grid h-[120px] w-full max-w-xs animate-pulse place-items-center rounded-lg bg-gray-300"></div>
}
